export default __webpack_public_path__ + "static/media/update_website.b8b541fa.svg";